import designItem from './DesignSelect.vue'
const DesignSelect = {
  install: function (Vue) {
    Vue.component('DesignSelect', designItem)
  }
}
export default DesignSelect
